import React from 'react';

const Grid = ({ 
  children, 
  cols = 1, 
  gap = 0, 
  className = '',
  responsive = true 
}) => {
  const getGridCols = () => {
    if (!responsive) {
      const colMap = { 1: 'grid-cols-1', 2: 'grid-cols-2', 3: 'grid-cols-3', 4: 'grid-cols-4', 5: 'grid-cols-5', 6: 'grid-cols-6' };
      return colMap[cols] || 'grid-cols-1';
    }
    
    // Responsive grid classes
    const baseCols = Math.min(cols, 1);
    const smCols = Math.min(cols, 2);
    const mdCols = Math.min(cols, 3);
    const lgCols = Math.min(cols, 4);
    
    const colMap = { 1: 'grid-cols-1', 2: 'grid-cols-2', 3: 'grid-cols-3', 4: 'grid-cols-4', 5: 'grid-cols-5', 6: 'grid-cols-6' };
    const smColMap = { 1: 'sm:grid-cols-1', 2: 'sm:grid-cols-2', 3: 'sm:grid-cols-3', 4: 'sm:grid-cols-4', 5: 'sm:grid-cols-5', 6: 'sm:grid-cols-6' };
    const mdColMap = { 1: 'md:grid-cols-1', 2: 'md:grid-cols-2', 3: 'md:grid-cols-3', 4: 'md:grid-cols-4', 5: 'md:grid-cols-5', 6: 'md:grid-cols-6' };
    const lgColMap = { 1: 'lg:grid-cols-1', 2: 'lg:grid-cols-2', 3: 'lg:grid-cols-3', 4: 'lg:grid-cols-4', 5: 'lg:grid-cols-5', 6: 'lg:grid-cols-6' };
    
    return `${colMap[baseCols]} ${smColMap[smCols]} ${mdColMap[mdCols]} ${lgColMap[lgCols]}`;
  };

  const getGap = () => {
    if (gap === 0) return '';
    const gapMap = { 1: 'gap-1', 2: 'gap-2', 3: 'gap-3', 4: 'gap-4', 5: 'gap-5', 6: 'gap-6', 8: 'gap-8', 10: 'gap-10', 12: 'gap-12' };
    return gapMap[gap] || '';
  };

  return (
    <div className={`grid ${getGridCols()} ${getGap()} ${className}`}>
      {children}
    </div>
  );
};

export default Grid;
